// Feature detect your browser by adding classes to the document tag.
// So you can adapt your application for older browsers.

/* eslint-disable */
!(function () {
  let touch;
  let ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

  let hasHistoryFeature = function () {
    if (((ua.indexOf('Android 2.') !== -1) || (ua.indexOf('Android 4.0') !== -1)) &&
      (ua.indexOf('Mobile Safari') !== -1) &&
      (ua.indexOf('Chrome') === -1) &&
      (ua.indexOf('Windows Phone') === -1)) {
      return false;
    }

    return window.history && 'pushState' in window.history;
  };

  let hasWebsockets = () => 'WebSocket' in window && (window.WebSocket.CLOSING === 2);

  let hasFileApi = () => !!(window.File && window.FileList && window.FileReader);

  let hasTouchEvents = () =>
    'ontouchstart' in window || (window.DocumentTouch &&
    document instanceof DocumentTouch)
    ;

  let isInternetExplorer = () => /msie|trident/i.test(ua);

  let classes = [];

  let features = {
    history: hasHistoryFeature(),
    websocket: hasWebsockets(),
    file: hasFileApi(),
    touch: (touch = hasTouchEvents()),
    'no-touch': !touch,
    msie: isInternetExplorer()
  };

  for (let feature in features) {
    if (!features[feature]) {
      continue;
    }
    classes.push(feature);
  }

  let {documentElement} = document;
  let {className} = documentElement;
  let reJS = new RegExp('(^|\\s)no-js(\\s|$)');
  className = className.replace(reJS, '$1js $2');
  className += classes.join(' ');
  return documentElement.className = className;
})();



// WEBPACK FOOTER //
// ./main/assets/javascripts/degradizr.js